"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultMidColour = exports.defaultLightColour = exports.defaultFontFamily = exports.defaultDarkColour = void 0;
var _colours = require("../../fuse-colours/src/colours");
var _typography = require("../../fuse-typography/src/typography");
var very = _colours.brand.very;
var defaultFontFamily = exports.defaultFontFamily = _typography.fontFamily.very;
var defaultLightColour = exports.defaultLightColour = very.pinkLight;
var defaultMidColour = exports.defaultMidColour = very.pinkMid;
var defaultDarkColour = exports.defaultDarkColour = very.pinkDark;